import { render, staticRenderFns } from "./CloseOnClick.vue?vue&type=template&id=6ba92feb&"
import script from "./CloseOnClick.vue?vue&type=script&lang=js&"
export * from "./CloseOnClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports